// Which place a path shows: Me (/me/...), a workspace (/<slug>/...) or neither
// (sign-in, /new, /invite/...). Workspace slugs never take the screen's
// top-level paths (RESERVED_SLUGS), so the first segment tells them apart.
import {
  RESERVED_SLUGS,
  SLUG_PATTERN,
} from "@trameria/cloud-api/workspace-shared";

const reserved = new Set<string>(RESERVED_SLUGS);

export const inMePath = (path: string) =>
  path === "/me" || path.startsWith("/me/");

/** The workspace slug of a path, or null when the path is not a workspace's. */
export function slugOfPath(path: string): string | null {
  const first = path.split("/")[1] ?? "";
  if (!SLUG_PATTERN.test(first) || reserved.has(first)) return null;
  return first;
}

export const inWorkspacePath = (path: string) => slugOfPath(path) !== null;
